import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

class SwipeRxWmsApiStoCheckUpload extends SwipeRxWmsApi {
  private readonly basePath: string;

  constructor() {
    super(SwipeRxAPIResources.STO_CHECK_UPLOAD);
    this.basePath = `/${this.apiResource}`;
  }

  async uploadPhoto(stoNumber: string, basket: number, formData: FormData) {
    try {
      const result = await this.post(
        `${this.basePath}/${stoNumber}/${basket}/upload-basket-photo`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async deleteBasketPhoto(
    stoNumber: string,
    basket: number,
    photoLink: string,
  ) {
    try {
      const result = await this.delete(
        `${this.basePath}/${stoNumber}/${basket}/delete-basket-photo`,
        {
          photo_link: photoLink,
        },
      );
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }
}

export const swipeRxWmsApiStoCheckUpload = new SwipeRxWmsApiStoCheckUpload();
